export default __webpack_public_path__ + "static/media/illustration-recruit-2-m@3x.d85509dd.webp";